import React, { useState } from 'react';
import { ButtonBase } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { RootState } from 'interfaces';
import { HomeModuleTarget } from '../types';

interface IProps {
  target: HomeModuleTarget;
  className: string;
  children: React.ReactNode;
}

/** Кликабельная поверхность карточки: ссылка на страницу, внешний адрес в новой вкладке или кнопка диалога. */
const ModuleLink = ({ target, className, children }: IProps) => {
  const user = useSelector((state: RootState) => state.user);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  if (target.dialog !== undefined) {
    const Dialog = target.dialog;

    return (
      <>
        <ButtonBase focusRipple className={className} aria-haspopup="dialog" onClick={() => setIsDialogOpen(true)}>
          {children}
        </ButtonBase>
        <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} />
      </>
    );
  }

  if (target.href !== undefined) {
    return (
      <ButtonBase
        focusRipple
        className={className}
        component="a"
        href={target.href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </ButtonBase>
    );
  }

  const to = typeof target.to === 'function' ? target.to(user) : target.to;

  return (
    <ButtonBase focusRipple className={className} component={RouterLink} role="link" to={to}>
      {children}
    </ButtonBase>
  );
};

export default ModuleLink;
